/** Mirrors `validateSearch` for `/admin/expenses` (see `routes/admin/expenses.tsx`). */
export type ExpenseTab = 'overview' | 'ledger' | 'pnl'

export const EXPENSE_TABS = ['overview', 'ledger', 'pnl'] as const

export type ExpensesSearch = {
  tab?: ExpenseTab
  /** Ledger: category slug the list is filtered to. Set by every drill —
   *  a chip, a "Spend by category" row, the P&L breakdown. */
  category?: string
  /** The shared period bar (`useReportRange`): preset id and DD-MM-YYYY
   *  bounds. Pass-through so Reports → Expenses carries the same window. */
  preset?: string
  from?: string
  to?: string
  /** F-RPT-N43: a receipt scan to open in the review sheet (a shareable link). */
  receipt?: string
}

/** Tab ids the dashboard used before F-FE-N129, still reachable from old
 *  bookmarks: `expenses` was the ledger; `intelligence` folded into Overview. */
export function resolveExpenseTab(raw: unknown): ExpenseTab | undefined {
  if (typeof raw !== 'string') return undefined
  if (raw === 'expenses') return 'ledger'
  if (raw === 'intelligence') return 'overview'
  return (EXPENSE_TABS as readonly string[]).includes(raw) ? (raw as ExpenseTab) : undefined
}
